const menuItems = document.querySelectorAll('dropdown-menu');

menuItems.forEach(item => {
  item.addEventListener('mouseenter', e => {
    const { left, width } = item.getBoundingClientRect();
    // Remove all positional classes first to reset the state
    item.classList.remove('enter-left', 'enter-right', 'leave-left', 'leave-right');
    // Then add the appropriate class based on the entry direction
    if (e.clientX < left + (width / 2)) {
      item.classList.add('enter-left');
    } else {
      item.classList.add('enter-right');
    }
  });

  item.addEventListener('mouseleave', e => {
    requestAnimationFrame(() => {
      const { left, width } = item.getBoundingClientRect();
      // Remove the entry classes right before animation to ensure correct transition
      item.classList.remove('enter-left', 'enter-right');
      if (e.clientX < left + (width / 2)) {
        item.classList.add('leave-left');
      } else {
        item.classList.add('leave-right');
      }
    });
  });
});
